export default __webpack_public_path__ + "static/media/bg-evening.4f06061d.png";